import React from "react";
import { Routes, Route, Outlet } from "react-router-dom";

import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Blog from "./components/Blog";
import CGT270 from "./components/CGT270";
import Projects from "./components/Projects";
import Misc from "./components/Misc";
import Robotics from "./components/Robotics";
import Hextraction from "./components/Hextraction";
import Wallet from "./components/Wallet";
import NotFound from "./components/NotFound";

function NavbarLayout() {
  return (
    <div id="app">
      <Navbar />
      <Outlet />
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route element={<NavbarLayout />}>
        <Route index element={<Home />} />
        <Route path="Blog" element={<Blog />} />
        <Route path="Projects" element={<Projects />} />
        <Route path="Misc" element={<Misc />} />
        <Route path="CGT270" element={<CGT270 />} />
        <Route path="Robotics" element={<Robotics />} />
        <Route path="Hextraction" element={<Hextraction />} />
      </Route>

      {/* No navbar */}
      <Route path="Wallet" element={<Wallet />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}